import { useQuery } from '@tanstack/react-query';

import { getPromotionUsage } from '@arrived/api_v2';
import { Rewards } from '@arrived/models';

import { UseQueryOptions, UseQueryResult } from '../queries.utils';
import { promotionUsageKeyFn } from './rewards.keys';

export function useGetPromotionUsageQuery(
  promotionUuid?: string,
  options?: UseQueryOptions<Rewards.PromotionUsage>
): UseQueryResult<Rewards.PromotionUsage> {
  return useQuery(promotionUsageKeyFn(promotionUuid!), async () => getPromotionUsage(promotionUuid!), {
    ...options,
    enabled: (options?.enabled ?? true) && promotionUuid != null,
    staleTime: options?.staleTime,
  });
}
